import request from '@/utils/request'

// 获取招聘场次列表
export function getRecruitmentSessionList(params) {
  return request({
    url: '/recruitment-session',
    method: 'get',
    params
  })
}

// 添加招聘场次
export function createRecruitmentSession(data) {
  return request({
    url: '/recruitment-session',
    method: 'post',
    data
  })
}

// 获取招聘场次详情
export function getRecruitmentSession(id) {
  return request({
    url: `/recruitment-session/${id}`,
    method: 'get'
  })
}

// 编辑招聘场次
export function updateRecruitmentSession(id, data) {
  return request({
    url: `/recruitment-session/${id}`,
    method: 'post',
    data
  })
}

// 删除招聘场次
export function deleteRecruitmentSession(id) {
  return request({
    url: `/recruitment-session/${id}`,
    method: 'delete'
  })
}

// 批量删除招聘场次
export function batchDeleteRecruitmentSession(ids) {
  return request({
    url: '/recruitment-session/batch-delete',
    method: 'post',
    data: { ids }
  })
}

// 更新招聘场次状态
export function updateRecruitmentSessionStatus(id, status) {
  return request({
    url: `/recruitment-session/${id}/status`,
    method: 'post',
    data: { status }
  })
} 

export function getAllSessionList() {
  return request({
    url: '/recruitment-session/all',
    method: 'get'
  })
}


// WEBPACK FOOTER //
// ./src/api/recruitment-session.js